// src/components/DiscordWidget.jsx
import React from "react";
import "./DiscordWidget.css";

function DiscordWidget() {
  return (
    <div className="discord-widget">
      <h2>Join Our Discord</h2>
      <p>Be part of the Vortex Network community and stay updated!</p>
      <iframe
        src="https://discord.com/widget?id=797918728632664135&theme=dark"
        width="350"
        height="500"
//        allowTransparency="true"
        frameBorder="0"
        sandbox="allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-scripts"
        title="Vortex Discord"
      ></iframe>
    </div>
  );
}

export default DiscordWidget;
